export default [
    {
        value: 'HH',
        tipo : 'Dedicação horária dos membros da equipe de Gestão do Programa de P&D, do quadro efetivo da empresa.',
        categoria : ["RH - Recursos Humanos"],
    },
    {
        value: 'EC',
        tipo : 'Participação dos membros da equipe de gestão em eventos sobre pesquisa, desenvolvimento e inovação realacionados ao setor elétrico e/ou em cursos de gestão tecnológica e da informação.',
        categoria : ["OU - Outros","VD - Viagens e diárias"],
    },
    {
        value: 'FG',
        tipo : 'Desenvolvimento e aquisição de ferramentas e equipamentos de tecnologia da informação, para gestão do Programa de P&D da Empresa.',
        categoria : ["ST - Serviços de terceiros"],
    },
    {
        value: 'PP',
        tipo : 'Prospecção tecnológica e demais atividades necessárias ao planejamento e à elaboração do plano estratégico de investimento em P&D.',
        categoria : ["ST - Serviço de terceiros","VD - Viagens e diárias"],
    },
    {
        value: 'RP',
        tipo : 'Divulgação de resultados de projetos de P&D concluidos e/oi em execução.',
        categoria : ["MC - Materiais de consumo","OU - Outros","VD - Viagens e diárias"],
    },
    {
        value: 'AP',
        tipo : 'Participação dos responsáveis técnicos pelos projetos de P&D nas avaliações presenciais convocadas pela ANEEL.',
        categoria : ["VD - Viagens e diárias"],
    },
    {
        value : 'BA',
        tipo : 'Buscas de anterioridade no Instituto Nacional da Propriedade Industrial (INPI)',
        categoria : ["OU - Outros"],
    },
    {
        value : 'CA',
        tipo : 'Contratação de auditoria contábil e financeira para os projetos concluídos.',
        categoria : ["AC - Auditoria contábil e financeira"]
    },
    {
        value : 'AC',
        tipo : 'Apoio á realização do CITENEL',
        categoria : ["CT - CITENEL",]
    }
]